// ** React Imports

// ** Third Party Components
import { Key, Power, Shield, User as UserIcon } from 'react-feather';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';

// ** Default Avatar Image
import { useToggle } from '@src/@data/utility/hooks/useToggle';
import { formatName } from '@src/@data/utility/names';
import { useMessages } from '@data/utility/hooks/useMessages';
import { useAuth } from '@src/@data/store/AuthProvider';
import { ChangeUserPasswordModal } from '@src/components/organisms/password/ChangeUserPasswordModal';
import Avatar from '@src/components/atoms/avatar';
import { useLayoutContext } from '@src/@data/store/LayoutProvider';

const UserDropdown = () => {
  const { user, logout } = useAuth();
  const [isChangePasswordModalOpen, toggleChangePasswordModal] =
    useToggle(false);
  const { setCookieBannerHidden } = useLayoutContext();

  const { messages } = useMessages();

  if (!user) return null;

  return (
    <>
      <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
        <DropdownToggle
          color="transparent"
          className="dropdown-user-link px-50 py-0 d-flex align-items-center"
        >
          <Avatar
            img={user?.image?.url}
            icon={!user?.image?.url ? <UserIcon size={20} /> : undefined}
            imgHeight="32"
            imgWidth="32"
          />
          <div className="ml-50 user-nav d-sm-flex d-none">
            <h5 className="mb-0">
              {formatName(user.firstName, user.lastName)}
            </h5>
          </div>
        </DropdownToggle>
        <DropdownMenu right className="w-auto">
          <DropdownItem onClick={toggleChangePasswordModal}>
            <Key size={14} className="mr-75" />
            <span className="align-middle">
              {messages('nav_user_menu_change_password')}
            </span>
          </DropdownItem>
          <DropdownItem onClick={() => setCookieBannerHidden(false)}>
            <Shield size={14} className="mr-75" />
            <span className="align-middle">
              {messages('nav_user_menu_cookie_settings')}
            </span>
          </DropdownItem>
          <DropdownItem onClick={logout} className="w-100">
            <Power size={14} className="mr-75" />
            <span className="align-middle">
              {messages('nav_user_menu_logout')}
            </span>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
      {isChangePasswordModalOpen && (
        <ChangeUserPasswordModal toggle={toggleChangePasswordModal} />
      )}
    </>
  );
};

export default UserDropdown;
